import React, { useEffect, useRef, useState, useContext, createContext } from 'react';
import { Button, Form, Input, Row, Col, Select, Typography, DatePicker, DateTimePicker, message, Modal, InputNumber, MainModal, useProTableOt, ProTableOt, Accordion, AccordionItem, AccordionTrigger, AccordionContent, UploadAudio, UploadImg, Spin, Checkbox, Switch, TimeSelector, formatDateToTimeZone, RangePicker, ImportButton } from "../ui/ot";
import { useCRUDController } from "../ui/classify_structure/CRUDController";
import { useTranslation } from 'react-i18next';
import { useRecord } from './controller/record_controller';
import dayjs from 'dayjs';
import { PlusOutlined } from "@ant-design/icons";
const LanguageContext = createContext(null)


const ShiftOverviewCalender = ({
    keyPrefix = "shift_management.shift_overview_calender",
    propsForm,
    defaultValue = {},
    defaultSelectedRowsInfo = [],
    defaultSelectedRowsKeys = [],
    customColumns = [],
    customDefaultColumns = [],
    customFormItems = () => { },
    extraActionRender = () => { },
    toolBarRender = (tools) => ([...tools]),
    propsUseRecord = useRecord,
    propsOnFinish = () => { },
    propsOnBefore = () => { },
    propsOnValuesChange = () => { },
    propsShowKeys = [
        { key: "teacher_id", name: "教師姓名", hidden: false, require: false },
        { key: "dec_1st", name: "12/1（日）", hidden: false, require: false },
        { key: "dec_2nd", name: "12/2（一）", hidden: false, require: false },
        { key: "dec_3rd", name: "12/3（二）", hidden: false, require: false },
        { key: "dec_4th", name: "12/4（三）", hidden: false, require: false },
        { key: "dec_5th", name: "12/5（四）", hidden: false, require: false },
        { key: "dec_6th", name: "12/6（五）", hidden: false, require: false },
        { key: "dec_7th", name: "12/7（六）", hidden: false, require: false },
        { key: "dec_8th", name: "12/8（日）", hidden: false, require: false },
        { key: "dec_9th", name: "12/9（一）", hidden: false, require: false },
        { key: "dec_10th", name: "12/10（二）", hidden: false, require: false },
        { key: "dec_11th", name: "12/11（三）", hidden: false, require: false },
        { key: "dec_12th", name: "12/12（四）", hidden: false, require: false },
        { key: "dec_13th", name: "12/13（五）", hidden: false, require: false },
        { key: "dec_14th", name: "12/14（六）", hidden: false, require: false },
        { key: "dec_15th", name: "12/15（日）", hidden: false, require: false },
        { key: "dec_16th", name: "12/16（一）", hidden: false, require: false },
        { key: "dec_17th", name: "12/17（二）", hidden: false, require: false },
        { key: "dec_18th", name: "12/18（三）", hidden: false, require: false },
        { key: "dec_19th", name: "12/19（四）", hidden: false, require: false },
        { key: "dec_20th", name: "12/20（五）", hidden: false, require: false },
        { key: "dec_21st", name: "12/21（六）", hidden: false, require: false },
        { key: "dec_22nd", name: "12/22（日）", hidden: false, require: false },
        { key: "dec_23rd", name: "12/23（一）", hidden: false, require: false },
        { key: "dec_24th", name: "12/24（二）", hidden: false, require: false },
        { key: "dec_25th", name: "12/25（三）", hidden: false, require: false },
        { key: "dec_26th", name: "12/26（四）", hidden: false, require: false },
        { key: "dec_27th", name: "12/27（五）", hidden: false, require: false },
        { key: "dec_28th", name: "12/28（六）", hidden: false, require: false },
        { key: "dec_29th", name: "12/29（日）", hidden: false, require: false },
        { key: "dec_30th", name: "12/30（一）", hidden: false, require: false },
        { key: "dec_31st", name: "12/31（二）", hidden: false, require: false },
    ],
    defaultScheduleData = [
        {
            teacher_id: 'Irene',
            dec_1st: '休',
            dec_2nd: 'T',
            dec_3rd: '休',
            dec_4th: 'T',
            dec_5th: 'T',
            dec_6th: 'R',
            dec_7th: '休',
            dec_8th: '休',
            dec_9th: '休',
            dec_10th: 'T',
            dec_11th: 'T',
            dec_12th: 'T',
            dec_13th: '休',
            dec_14th: 'T',
            dec_15th: 'T',
            dec_16th: 'T',
            dec_17th: '特',
            dec_18th: 'T',
            dec_19th: 'T',
            dec_20th: '休',
            dec_21st: 'T',
            dec_22nd: '休',
            dec_23rd: 'T',
            dec_24th: '休',
            dec_25th: '休',
            dec_26th: 'T',
            dec_27th: 'T',
            dec_28th: 'T',
            dec_29th: '特',
            dec_30th: '休',
            dec_31st: '休'
        },
        {
            teacher_id: 'Iris',
            dec_1st: '休',
            dec_2nd: 'T',
            dec_3rd: 'T',
            dec_4th: 'T',
            dec_5th: '特',
            dec_6th: 'T',
            dec_7th: 'T',
            dec_8th: '休',
            dec_9th: '休',
            dec_10th: '休',
            dec_11th: 'T',
            dec_12th: 'T',
            dec_13th: 'T',
            dec_14th: '休',
            dec_15th: 'T',
            dec_16th: 'T',
            dec_17th: 'R',
            dec_18th: '休',
            dec_19th: 'T',
            dec_20th: 'T',
            dec_21st: 'T',
            dec_22nd: '特',
            dec_23rd: '休',
            dec_24th: 'T',
            dec_25th: 'T',
            dec_26th: 'R1',
            dec_27th: 'T',
            dec_28th: '休',
            dec_29th: 'T',
            dec_30th: 'T',
            dec_31st: '休'
        },
        {
            teacher_id: 'Erin',
            dec_1st: '特',
            dec_2nd: 'T',
            dec_3rd: 'T',
            dec_4th: 'T',
            dec_5th: 'T',
            dec_6th: 'R1',
            dec_7th: '休',
            dec_8th: 'T',
            dec_9th: 'T',
            dec_10th: '休',
            dec_11th: '休',
            dec_12th: 'T',
            dec_13th: 'T',
            dec_14th: 'R1',
            dec_15th: 'T',
            dec_16th: 'T',
            dec_17th: '特',
            dec_18th: 'T',
            dec_19th: 'T',
            dec_20th: 'T',
            dec_21st: '休',
            dec_22nd: '休',
            dec_23rd: 'T',
            dec_24th: 'T',
            dec_25th: 'T',
            dec_26th: '特',
            dec_27th: '休',
            dec_28th: 'T',
            dec_29th: 'T',
            dec_30th: 'T',
            dec_31st: '休'
        },
    ],
    apiRoute = "/shift_management/api/schedule_record"
}) => {
    const { t } = useTranslation("translation", { keyPrefix });
    const [shifts, setShifts] = useState([]);
    const [extra_columns, set_extra_columns] = useState([]);
    const actionRef = useRef();
    const defaultColumns = [
        {
            title: '教師姓名',
            dataIndex: 'teacher_id',
            key: 'teacher_id',
            align: "center",
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/1（日）',
            dataIndex: 'dec_1th',
            key: 'dec_1th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/2（一）',
            dataIndex: 'dec_2th',
            key: 'dec_2th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/3（二）',
            dataIndex: 'dec_3th',
            key: 'dec_3th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/4（三）',
            dataIndex: 'dec_4th',
            key: 'dec_4th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/5（四）',
            dataIndex: 'dec_5th',
            key: 'dec_5th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/6（五）',
            dataIndex: 'dec_6th',
            key: 'dec_6th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/7（六）',
            dataIndex: 'dec_7th',
            key: 'dec_7th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/8（日）',
            dataIndex: 'dec_8th',
            key: 'dec_8th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/9（一）',
            dataIndex: 'dec_9th',
            key: 'dec_9th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/10（二）',
            dataIndex: 'dec_10th',
            key: 'dec_10th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/11（三）',
            dataIndex: 'dec_11th',
            key: 'dec_11th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/12（四）',
            dataIndex: 'dec_12th',
            key: 'dec_12th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/13（五）',
            dataIndex: 'dec_13th',
            key: 'dec_13th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/14（六）',
            dataIndex: 'dec_14th',
            key: 'dec_14th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/15（日）',
            dataIndex: 'dec_15th',
            key: 'dec_15th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/16（一）',
            dataIndex: 'dec_16th',
            key: 'dec_16th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/17（二）',
            dataIndex: 'dec_17th',
            key: 'dec_17th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/18（三）',
            dataIndex: 'dec_18th',
            key: 'dec_18th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/19（四）',
            dataIndex: 'dec_19th',
            key: 'dec_19th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/20（五）',
            dataIndex: 'dec_20th',
            key: 'dec_20th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/21（六）',
            dataIndex: 'dec_21st',
            key: 'dec_21st',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/22（日）',
            dataIndex: 'dec_22nd',
            key: 'dec_22nd',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/23（一）',
            dataIndex: 'dec_23rd',
            key: 'dec_23rd',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/24（二）',
            dataIndex: 'dec_24th',
            key: 'dec_24th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/25（三）',
            dataIndex: 'dec_25th',
            key: 'dec_25th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/26（四）',
            dataIndex: 'dec_26th',
            key: 'dec_26th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/27（五）',
            dataIndex: 'dec_27th',
            key: 'dec_27th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/28（六）',
            dataIndex: 'dec_28th',
            key: 'dec_28th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/29（日）',
            dataIndex: 'dec_29th',
            key: 'dec_29th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/30（一）',
            dataIndex: 'dec_30th',
            key: 'dec_30th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/31（二）',
            dataIndex: 'dec_31st',
            key: 'dec_31st',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
    ];
    const columns = [
        ...customColumns,
        ...defaultColumns.filter(column => propsShowKeys.some(keyObj => keyObj.key === column.key && keyObj.hidden !== true)),
    ]

    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [selectedRowsInfo, setSelectedRowsInfo] = useState([])

    const [modalOpen, setModalOpen] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)

    const [form_] = Form.useForm();
    const form = propsForm || form_;
    const [axiosMode, setAxiosMode] = useState("get")

    const [importData, setImportData] = useState([]);
    const [import_modal, set_import_modal] = useState(false);
    const [upload_modal, set_upload_modal] = useState(false)

    const onFinish = ({ axiosMode, status, values }) => {
        propsOnFinish({ axiosMode, status, values });
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功")
                actionRef.current.reload();

            }
            else if (axiosMode === "patch") {
                message.success("修改成功")
                actionRef.current.reload();

            }
            else if (axiosMode === "delete") {
                message.success("刪除成功")
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([])
                setSelectedRowsInfo([])
            }
            if (axiosMode !== "get") {
                setModalLoading(false)
                setModalOpen(false)
            }
        }
        else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗")
                // actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "patch") {
                message.error("修改失敗")
                // actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "delete") {
                message.error("刪除失敗")
                // actionRef.current.reloadAndRest();
            }
            // setModalLoading(false)
            // setModalOpen(false)
        }
    }

    const handleDeleteRow = (id) => {
        /* 刪除單／多筆資料 */
        let data = []
        /* 將PK做成陣列 */
        if (id) {
            /* 當單筆刪除時會帶入id */
            data = [{
                record_id: id
            }]
            /* 放入欲刪除的陣列 */
        }

        else {
            data = selectedRowsInfo.map((val) => {
                /* 將已勾選的資料遍歷 */
                return {
                    record_id: val?.record_id
                }
                /* 取出pk放回陣列 */
            })
        }
        if (data.length > 0) {
            /* 防呆未勾選任何資料 */
            Modal.confirm({
                /* 一次性使用Modal且有確定與取消的按鈕 */
                content: '確定要刪除嗎？',
                /* modal內容 */
                onOk: () => {
                    deleteData(data)
                    /* 當按下確定後觸發刪除資料 */
                },
                okText: '確定',
                /* 確定的按鈕顯示的文字 */
                cancelText: '取消',
                /* 取消的按鈕顯示的文字 */
            })
        }
        else {
            message.info("請選擇項目")
            /* 一次性呈現上方提示字 */
        }
    }

    const onBefore = ({ axiosMode, status, values }) => {
        propsOnBefore({ axiosMode, status, values })
    }

    const onFormFinish = (values) => {
        if (axiosMode === "post") {
            postData([values])
        }
        else if (axiosMode === "patch") {
            patchData([values])
        }
    }

    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectedRowsInfo]

            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value.record_id)
                    selectRow.push(value)
                })

            }
            else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value.record_id);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);

                })
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)

        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectedRowsInfo]

            if (selected) {
                select_temp.push(record.record_id)
                selectRow.push(record)
            }
            else {
                select_temp = select_temp.filter(key => key !== record.record_id)
                selectRow = selectRow.filter(row => row.record_id !== record.record_id)
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)

        },
        getCheckboxProps: (record) => ({
            // disabled: record.pass === null,
        }),
    };

    const onCleanSelected = () => {
        setSelectedRowKeys([])
        setSelectedRowsInfo([])
    }

    const setParamsFilter = (obj) => {
        obj = trimObjectArray([obj]).find(_ => true);
        return Object.entries(obj).reduce((all, [key, value]) => value === "" ? { ...all } : { ...all, [key]: value }, {})
    }

    const trimObjectArray = (data) => {
        return data.map(item => {
            // 创建一个新对象来避免修改原始对象
            const trimmedItem = {};
            for (const key in item) {
                if (Object.prototype.hasOwnProperty.call(item, key)) {
                    const value = item[key];
                    // 检查值是否为字符串
                    if (typeof value === 'string') {
                        trimmedItem[key] = value.trim();
                    } else {
                        trimmedItem[key] = value;
                    }
                }
            }
            return trimmedItem;
        });
    }

    const changeData = (record) => {
        let data_tmp = importData.filter(item => item.index != record.index);
        setImportData(data_tmp);
    }

    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useProTableOt({
        columns
    })

    const {
        ResponseData,
        getData,
        postData,
        patchData,
        deleteData,
        exportData,
        downloadData,
        overData,
    } = useCRUDController({
        apiRoute: apiRoute,
        onBefore: onBefore,
        onFinish: onFinish
    })

    return (
        <>
            <Row gutter={[8, 8]}>
                <Col span={24}>
                    <ProTableOt
                        actionRef={actionRef}
                        columns={columns}
                        check={check}
                        setCheck={setCheck}
                        headerTitle={<></>}
                        request={async (params = {}, sort, filter) => {
                            setAxiosMode("get")
                            let newParams = {
                            };
                            let order = setOrders(sort)
                            newParams = {
                                ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                                ...newParams,
                                ...filter,
                                order,
                                size: params?.pageSize,
                                cur_page: params?.current,
                                custom_filter_value: params?.keyword ?? "",
                                custom_filter_key: custom_filter_key
                            };
                            newParams = setParamsFilter({
                                ...newParams,
                            });
                            return getData(newParams)
                        }}
                        rowKey={'record_id'}
                        extra_columns={extra_columns}
                        set_extra_columns={set_extra_columns}
                        manage_columns={false}
                        scroll={{
                            x: "max-content"
                        }}
                        toolBarRender={() => toolBarRender([
                          
                        ])}
                        rowSelection={{
                            type: 'checkbox',
                            selectedRowKeys: selectedRowKeys,
                            setSelectedRowKeys: setSelectedRowKeys,
                            selectedRowsInfo: selectedRowsInfo,
                            setSelectedRowsInfo: setSelectedRowsInfo,
                            ...rowSelection,
                        }}
                        tableAlertRender={({ selectedRowKeys, selectedRows }) => {
                            return (
                                <div className="space-y-4">
                                    <span>
                                        已選 {selectedRowKeys.length} 項
                                        <Typography.P style={{ marginInlineStart: 8 }}
                                            onClick={onCleanSelected}>
                                            取消選擇
                                        </Typography.P>
                                    </span>
                                </div>
                            );
                        }}
                        defaultSelectedRowsInfo={defaultSelectedRowsInfo}
                        defaultSelectedRowsKeys={defaultSelectedRowsKeys}
                        axiosMode={axiosMode}
                        modalOpen={modalOpen}
                        setModalOpen={setModalOpen}
                        propsWidth={1000}
                    />
                </Col>
            </Row>
        </>
    );
};
export default ShiftOverviewCalender;
